"use client";

import React from "react";
import { Instagram, Facebook, Twitter, CreditCard, Banknote, Wallet, Landmark } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const supportLinks = [{
  label: "Platform Overview",
  href: "#"
}, {
  label: "Digital Twins",
  href: "#"
}, {
  label: "Case Studies",
  href: "#"
}, {
  label: "Contact Us",
  href: "/PropVRaiRedesignPage"
}];
const socialLinks = [{
  icon: Instagram,
  label: "Instagram",
  href: "#"
}, {
  icon: Facebook,
  label: "Facebook",
  href: "#"
}, {
  icon: Twitter,
  label: "Twitter",
  href: "#"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 animate-pulse rounded-sm bg-muted/20" />
          </li>)}
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="inline-block text-sm text-muted-foreground transition-all duration-300 hover:translate-x-[2px] hover:text-[#1755FD]">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function SiteFooter() {
  return <section data-section-id="206096" id="global-footer" className="bg-[#0E0C15] pt-16 pb-8 dark">
      <div className="mx-auto max-w-screen-xl px-4 md:px-8">
        <Separator className="mb-16 bg-[#2D2B35]" />

        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4">
          {}
          <div className="flex flex-col gap-6">
            <Link to="#" className="inline-block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621178/img/skyrecliners_logo_footer.png" alt="PropVR.ai" className="h-7 w-auto object-contain object-left brightness-0 invert" />
            </Link>
            <div className="flex flex-col gap-2 text-sm text-muted-foreground font-default">
              <p>
                PropVR.ai Headquarters, Innovation Park, Silicon Valley, CA 94025
              </p>
              <p>+1 (888) 776-7872</p>
              <p>hello@propvr.ai</p>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default text-base font-semibold text-white">
              Solutions
            </h3>
            <MenuProvider menu_id="footer_menu">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default text-base font-semibold text-white">
              Company
            </h3>
            <ul className="flex flex-col gap-3">
              {supportLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="inline-block text-sm text-muted-foreground transition-all duration-300 hover:translate-x-[2px] hover:text-[#1755FD] font-default">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default text-base font-semibold text-white">
              Connect
            </h3>
            <div className="flex gap-3">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Button key={social.label} variant="outline" size="icon" className="size-10 rounded-xl border-[#2D2B35] bg-transparent text-white transition-colors duration-300 hover:bg-[#1755FD] hover:border-[#1755FD] hover:text-white" asChild data-index={i}>
                    <Link to={social.href} aria-label={social.label}>
                      <Icon className="size-4" />
                    </Link>
                  </Button>;
            })}
            </div>
          </div>
        </div>

        {}
        <div className="mt-16 flex flex-col items-center justify-between gap-6 border-t border-[#2D2B35] pt-8 md:flex-row">
          <p className="text-sm text-muted-foreground font-default">
            © {new Date().getFullYear()} PropVR.ai. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-muted-foreground/50">
            <CreditCard className="size-5 transition-colors hover:text-white" />
            <Banknote className="size-5 transition-colors hover:text-white" />
            <Wallet className="size-5 transition-colors hover:text-white" />
            <Landmark className="size-5 transition-colors hover:text-white" />
          </div>
        </div>
      </div>
    </section>;
}